module.exports = __webpack_public_path__ + "img/01.b9d39400.jpg";